import Button from "../common/Button";
import BaseModal from "./BaseModal";

export default function LeadUploadModal({
  open,
  file,
  activate,
  busy,
  onFileChange,
  onActivateChange,
  onSubmit,
  onClose,
}) {
  return (
    <BaseModal
      open={open}
      onClose={busy ? () => {} : onClose}
      title="Lead Context Upload"
      meta="Upload Excel/CSV file to build outbound lead cache."
      modalId="leadContextModal"
    >
      <form className="outbound-form" onSubmit={onSubmit}>
        <div className="outbound-field">
          <label className="outbound-label" htmlFor="leadContextFile">
            Excel or CSV File
          </label>
          <input
            className="outbound-input"
            id="leadContextFile"
            name="file"
            type="file"
            accept=".xlsx,.csv"
            required
            onChange={(event) => onFileChange(event.target.files?.[0] || null)}
            disabled={busy}
          />
          {file ? <div className="file-meta">{file.name}</div> : null}
        </div>
        <label className="lead-upload-checkbox" htmlFor="leadContextActivate">
          <input
            id="leadContextActivate"
            name="activate"
            type="checkbox"
            checked={activate}
            onChange={(event) => onActivateChange(event.target.checked)}
            disabled={busy}
          />
          Enable for outbound calls immediately
        </label>
        <div className="outbound-actions">
          <Button onClick={onClose} disabled={busy}>
            Cancel
          </Button>
          <Button type="submit" variant="primary" disabled={busy}>
            {busy ? "Uploading..." : "Upload & Build"}
          </Button>
        </div>
      </form>
    </BaseModal>
  );
}
